import firebase from '../api/firestore';

const db = firebase.firestore();

export const getPost = (slug) =>
  db.collection('posts').doc(slug).get()
    .then(doc => doc.exists ? { id: doc.id, ...doc.data() } : null);

export const getPostsByCategory = (category) =>
  db.collection('posts')
    .where('category', '==', category)
    .where('published', '==', true)
    .orderBy('publishedAt', 'desc')
    .get()
    .then(snap => snap.docs.map(d => ({ id: d.id, ...d.data() })))
    .catch(() =>
      // Firestore may need a composite index on first run — fall back to unordered
      db.collection('posts')
        .where('category', '==', category)
        .where('published', '==', true)
        .get()
        .then(snap => snap.docs.map(d => ({ id: d.id, ...d.data() })))
    );

export const getAllPosts = () =>
  db.collection('posts')
    .where('published', '==', true)
    .orderBy('publishedAt', 'desc')
    .get()
    .then(snap => snap.docs.map(d => ({ id: d.id, ...d.data() })));

export const upsertPost = (slug, data) =>
  db.collection('posts').doc(slug).set(data, { merge: true });

export const seedAllPosts = async (posts) => {
  const batch = db.batch();
  posts.forEach(post => {
    const ref = db.collection('posts').doc(post.slug);
    const { slug, ...data } = post;
    batch.set(ref, {
      ...data,
      publishedAt: firebase.firestore.Timestamp.fromDate(
        data.publishedAt instanceof Date ? data.publishedAt : new Date(data.publishedAt)
      ),
    }, { merge: true });
  });
  await batch.commit();
  console.log(`✅ Seeded ${posts.length} posts to Firestore`);
};
